// Cloudflare RealtimeKit's `meeting.leave()` does not reliably stop the
// underlying local MediaStreamTracks in Chrome when the site has persistent
// microphone/camera permission ("Allow every visit"), which leaves the OS
// recording indicator on until the tab is closed. Stopping the tracks
// ourselves releases the hardware.
export const stopLocalTracks = (meeting: any) => {
  try {
    const self: any = meeting?.self;
    if (!self) return;

    const candidates: Array<MediaStreamTrack | undefined | null> = [
      self.audioTrack,
      self.videoTrack,
      self.screenShareTracks?.audio,
      self.screenShareTracks?.video,
    ];

    for (const track of candidates) {
      if (track && typeof track.stop === "function" && track.readyState !== "ended") {
        track.stop();
      }
    }
  } catch (e) {
    // Best-effort cleanup; never block the leave flow.
  }
};
